/**
 * Remembers the department the user last browsed (written by DepartmentLayout) so top-level
 * pages like /quiz can link into the right department. The app stores no per-user default
 * department, so this is a per-browser convenience; falls back to 'parts'.
 */

import { departmentOrder, type Department } from '@/shared/components/Sidebar/sidebar-config';

const KEY = 'botr:lastDepartment';
export const DEFAULT_DEPARTMENT: Department = 'parts';

export function isDepartment(value: unknown): value is Department {
  return typeof value === 'string' && (departmentOrder as string[]).includes(value);
}

export function rememberDepartment(department: Department): void {
  try {
    localStorage.setItem(KEY, department);
  } catch {
    /* storage unavailable */
  }
}

export function getLastDepartment(): Department {
  try {
    const v = localStorage.getItem(KEY);
    return isDepartment(v) ? v : DEFAULT_DEPARTMENT;
  } catch {
    return DEFAULT_DEPARTMENT;
  }
}

export function quizManagePathFor(department: Department): string {
  return `/${department}/quizzes`;
}
